import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
	SET_SCREEN: type<'SET_SCREEN'>('SET_SCREEN'),
};

// Action type for screen
export class SetScreen implements Action {
	type = ActionTypes.SET_SCREEN;
	/**
	 *Creates an instance of SetScreen.
	 * @param {number} payload
	 * @memberof SetScreen
	 */
	public constructor(public payload: number) { }
}

export type Actions = SetScreen;
